import {z} from '@hono/zod-openapi';

import {count} from './count';
import {DeadStockCardSchema} from './DeadStockCardSchema';
import {DeadStockSummaryBucketSchema} from './DeadStockSummaryBucketSchema';

export const DeadStockSnapshotResponseSchema = z
  .object({
    asOf: z.string().date(),
    capturedAt: z.string(),
    timezone: z.string(),
    /** Every bucket, folded over the whole population rather than over `cards`. */
    buckets: z.array(DeadStockSummaryBucketSchema),
    /** One page of the cards matching the filters, including `bucket`. */
    cards: z.array(DeadStockCardSchema),
    /**
     * Cards matching every filter, `bucket` included, before the page cap. The caller pages
     * with `offset` until it has this many.
     */
    totalCardCount: count.default(0),
    /**
     * Cards whose value could not be determined because a contributing movement is
     * unpriced. Reported so the UI can show a data-quality note; the report itself stays
     * available rather than failing tenant-wide on a single ambiguous card.
     */
    invalidBalanceCount: count.default(0),
  })
  .openapi('DeadStockSnapshotResponse');

export type DeadStockSnapshotResponse = z.infer<typeof DeadStockSnapshotResponseSchema>;
